import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column full-width" }

import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { AttachmentType } from 'SharedDir/declarations/files';


import FileListItem from './FileListItem.vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileList' },
  __name: 'FileList',
  props: {
    modelValue: {},
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);
function remove(index: number) {
  innerValue.value.splice(index, 1);
  emitValue();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue), (item, index) => {
      return (_openBlock(), _createBlock(FileListItem, {
        key: item.id,
        class: "q-mb-xs",
        data: item,
        readonly: _ctx.readonly,
        "preview-in-window": "",
        onRemove: ($event: any) => (remove(index))
      }, null, 8, ["data", "readonly", "onRemove"]))
    }), 128))
  ]))
}
}

})